$(document).ready(function () {
  $('.ga-cta').on('click', function() {

    var ctaName = $(this).text()
    var location = window.location.pathname+' / '+ctaName

    ga('send', 'event', 'cta', 'click', location)
    localStorage.setItem('lastCta', location)
  })

  $('.ga-cta-form').each(function () {

    var data = $(this).data()

    ga('send', 'event', data.ctaName, 'send')
  })

  $('input[name=contact-form-cta]').each(function () {

    $(this).val(localStorage.getItem('lastCta'))
  })

})



// WEBPACK FOOTER //
// ./resources/assets/js/ga.js